import { useEffect, useState } from "react";
import GoogleMapsAPILoader from '../../services/GoogleMaps.service';
import TourListCard from "../tour-list-card/TourListCard";
import Modal from "react-bootstrap/Modal";
import styles from "./MapView.module.css";
// import { AUBERGINE, DARK_MODE, NIGHT_MODE, RETRO } from './MapTheme';
import { AUBERGINE } from './MapTheme';

export default function MapView(props) {
    
    const { tours } = props;
    const [ currentTour, setCurrentTour] = useState(null);

    useEffect(() => {
        const mapOptions = {
            center: {
                lat:  24,
                lng:  54,
            },
            zoom:  2,
            disableDefaultUI: true,
            styles: AUBERGINE
        };
        const initMap = async () => {
            GoogleMapsAPILoader.load().then((google) => {
                var map = new google.maps.Map(
                document.getElementById("map"),
                mapOptions
                );

                tours.forEach(tour => {
                    new google.maps.Marker({
                        position: { lat: tour.info.latitude, lng: tour.info.longitude } ,
                        map: map,
                        title: tour.info.tourName,
                    }).addListener("click", () => {
                        setCurrentTour(tour);
                    });
                })
            });
        };
        initMap();
    }, [ tours ]);

  return (
    <>
        <div id="map" style={{ width: "100%", height: "100%" }} ></div>
        { currentTour && 
            <Modal
                show={!!currentTour}
                onHide={() => setCurrentTour(null)}
                centered
                contentClassName={styles.tourCardModal}
            >
                {/* <Modal.Header closeButton /> */}
                <Modal.Body>
                    <TourListCard 
                        tour={currentTour} 
                        onDelete={() => setCurrentTour(null)}
                    />
                </Modal.Body>  
            </Modal>
        }    
    </>
  );
}
